import { createVanIconComponent } from "./van"

const WapHomeOutlined = createVanIconComponent("wap-home-o")
export default WapHomeOutlined
